export const InvestmentsHeaders = [["Investment.ID", "Investment.Name"]];

export const PortfoliosHeaders = [
  [
    "Portfolio.ID",
    "Portfolio.Name",
    "Portfolio.Currency",
    "Portfolio.Type",
    "Portfolio.Group ID",
    "Portfolio.Group Name",
  ],
];

export const SelectionSetHeaders = [
  ["SelectionSet.ID", "SelectionSet.Name", "SelectionSet.Type", "SelectionSet.IsFolder", "SelectionSet.ParentID"],
];

export const AttributeHeaders = [
  [
    "Attribute.Name",
    "Attribute.ForUseWithBurgissGetAttributeFunction",
    "Attribute.ForUseWithInvestmentCalcFilterParameter",
    "Attribute.ForUseWithHoldingCalcFilterParameter",
  ],
];

export const IndexHeaders = [
  [
    "Index.ID",
    "Index.Name",
    "Index.Values.StartDate",
    "Index.Values.EndDate",
    "Index.IsBurgissManaged",
    "Index.IsUniverseAnalyticsEligible",
    "Index.UseWithUniverseAnalytics",
  ],
];

export const PeerGroupHeaders = [
  ["PeerGroup.ID", "PeerGroup.Name", "PeerGroup.VehicleType", "PeerGroup.IsBurgissManaged"],
];

export const InvestorHeaders = [["Investor.ID", "Investor.Name"]];

export const CalculationSetHeaders = [["CalculationSet.ID", "CalculationSet.Name"]];

export const CurrencyHeaders = [["Currency"]];

export const FiterFieldHeaders = [["VehicleType", "Field"]];

export const FiterValuesHeaders = [["VehicleType", "Field", "Value"]];

export const MeasurementDateHeaders = [["StartDate", "EndDate"]];

export const PortfolioTypes = [
  { name: "Investments", label: "Investments" },
  { name: "Investors", label: "Investors" },
  { name: "FundofFunds", label: "Fund of Funds" },
];
